import LabelWithTooltip from './LabelWithTooltip';

export default LabelWithTooltip;
